import { render, staticRenderFns } from "./AddColor.vue?vue&type=template&id=3d742b63&"
import script from "./AddColor.vue?vue&type=script&lang=js&"
export * from "./AddColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports